if (!customElements.get('mp4-player')) {
  customElements.define(
    'mp4-player',
    class Mp4Player extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const clickedEl = e.target.closest('[data-action]');
          if (!clickedEl) return;
          
          const {
            action
          } = clickedEl.dataset;
          
          switch(action) {
            case 'pause':
              this.classList.remove('playing');
              this.querySelector('video')?.pause();
            break;
            case 'play':
              this.classList.add('playing');
              this.querySelector('video')?.play();
            break;
            default: break;
          }
   
        })
      }
    }
  );
}